const DATE_OPTIONS = { year: 'numeric', month: 'numeric', day: 'numeric' }

/**
 * De notitiekolom van een project: de titel en datum van de nieuwste
 * projectnotitie, '+n' als er meer zijn, en met `onAdd` de knop '+ Notitie'.
 * Aanpassen en verwijderen gebeurt op de projectpagina, tabblad 'Notities'.
 * Gedeeld door het projectenoverzicht en de dashboardkaart 'Projecten met ster'.
 * AI-CONTEXT: See src/helpers/portfolio/projectNotesSummary.js
 * AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
 *
 * @param {object} props
 * @param {import('../../helpers/portfolio/projectNotesSummary').ProjectNoteSummary} [props.summary] - Nieuwste notitie en aantal; ontbreekt = geen notities
 * @param {boolean} props.loaded - Of de notities binnen zijn; zo niet, dan beweert de cel nog niets
 * @param {boolean} [props.failed] - Het lezen van de notities mislukte; de cel zegt dat in plaats van eeuwig te laden
 * @param {string} props.projectName - Naam van het project, voor de knop '+ Notitie'
 * @param {() => void} [props.onAdd] - Opent het notitievenster; ontbreekt = geen knop (geen bewerkrecht)
 * @returns {JSX.Element}
 */
const ProjectNoteSummary = ({ summary, loaded, failed = false, projectName, onAdd }) => (
    <div className='project-note-cell'>
        <NoteSummaryText summary={summary} loaded={loaded} failed={failed} />
        {onAdd && (
            <button
                type='button'
                className='multi-chip-picker__add project-note-add'
                aria-label={`Notitie toevoegen bij ${projectName}`}
                title='Notitie toevoegen'
                onClick={(e) => {
                    // De rij eromheen kan zelf klikbaar zijn.
                    e.stopPropagation()
                    onAdd()
                }}
            >
                + Notitie
            </button>
        )}
    </div>
)

/**
 * @param {object} props
 * @param {import('../../helpers/portfolio/projectNotesSummary').ProjectNoteSummary} [props.summary]
 * @param {boolean} props.loaded
 * @param {boolean} props.failed
 * @returns {JSX.Element}
 */
const NoteSummaryText = ({ summary, loaded, failed }) => {
    if (failed) return <span className='project-note-summary--empty'>Kon niet laden</span>
    if (!loaded) return <span className='project-note-summary--empty'>…</span>
    if (!summary) return <span className='project-note-summary--empty'>—</span>

    const { latest, count } = summary
    const date = typeof latest.Timestamp?.toDate === 'function'
        ? latest.Timestamp.toDate().toLocaleDateString('nl-NL', DATE_OPTIONS)
        : null

    return (
        <div className='project-note-summary'>
            <span className='project-note-summary__title'>{latest.Title || 'Zonder titel'}</span>
            {date && <span className='project-note-summary__date'>{date}</span>}
            {count > 1 && <span className='project-note-summary__more'>{`+${count - 1}`}</span>}
        </div>
    )
}

export default ProjectNoteSummary
